export default "__VITE_ASSET__CrVOLp2C__"